<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-layout class="fill-viewport-height">
            <router-view />
        </v-layout>
      </v-content>
    </v-app>
  </div>
</template>


<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "sass/globals";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  font-size: 16px;
  line-height: 18px;
  font-family: Raleway-Regular;
}
img {
  max-width: 100%;
}
.fill-viewport-height {
  height: 100vh; //Antes estaba 100% pero no funcionaba en navegadores iOS
}
p{
    font-size: 1em!important;
    line-height: 1.3em;
}

/********************  FONTS ********************/
/* Las fuentes se cargan acá porque se tiene acceso a los recursos que están en assets*/

@font-face {
  font-family: Raleway-Regular;
  src: url("./assets/fonts/Raleway-Regular.ttf");
}
@font-face {
  font-family: Raleway-Bold;
  src: url("./assets/fonts/Raleway-Bold.ttf");;
}
@font-face {
  font-family: Raleway-Light;
  src: url("./assets/fonts/Raleway-Light.ttf"); //no tiene Bolditalic
}

</style>

